// React
import React from 'react'

// Animation
import { motion } from 'framer-motion'

// Utils
import { Join } from '../../lib/utils'

interface ActionButtonProps {
  onClick: () => void
  className?: string
  classNames?: string
  children?: React.ReactNode
  title?: string
  ariaLabel?: string
}

export const ActionButton: React.FC<ActionButtonProps> = ({
  onClick,
  className = 'bg-blue-600/80 hover:bg-blue-700',
  classNames = 'text-white px-6 py-2 rounded-full transition-colors pointer-events-auto',
  children = 'Replay',
  title = 'Replay animation',
  ariaLabel = 'Replay the chat animation from the beginning',
}) => {
  return (
    <motion.button
      onClick={onClick}
      className={Join(className, classNames)}
      title={title}
      aria-label={ariaLabel}
      role="button"
      initial={{ opacity: 0, y: 8 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: 8 }}
    >
      {children}
    </motion.button>
  )
}
